// extracted by mini-css-extract-plugin
export default {"benefit__card":"benefit-card_benefit__card__P1JOL","benefit__text":"benefit-card_benefit__text__A8PWo"};